import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { media } from 'src/styles/styled-components'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'

const verticalGaps = [ 35, 60, 100 ]
const horizontalGaps = [ null, '40px', '7.5%' ]

const StyledWrapper = styled.section`
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  padding-bottom: 40px;
  padding-top: 30px;

  ${ media.tablet`
    padding-top: 60px;
    padding-bottom: 85px;
  ` }

  ${ media.desktop`
    padding-top: 160px;
    padding-bottom: 160px;
  ` }
`

const StyledContainer = styled(ArBaseContainer)`
  margin-bottom: ${ -verticalGaps[0] + 'px' };

  ${ media.tablet`
    margin-bottom: ${ -verticalGaps[1] + 'px' };
  ` }

  ${ media.desktop`
    margin-bottom: ${ -verticalGaps[2] + 'px' };
  ` }
`

const StyledTitle = styled.h2`
  font-size: 28px;
  line-height: 1.18;
  margin-bottom: 20px;
  text-align: center;

  ${ media.tablet`
    font-size: 38px;
    margin-bottom: 10px;
  ` }

  ${ media.desktop`
    font-size: 45px;
    margin-bottom: 20px;
  ` }
`

const StyledDescription = styled.p`
  font-size: 18px;
  letter-spacing: 0.01em;
  line-height: 1.55;
  text-align: center;

  ${ media.desktop`
    line-height: 1.6;
    font-size: 28px;
  ` }
`

const StyledList = styled.ul`
  margin-top: 40px;

  ${ media.tablet`
    margin-top: 60px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-left: ${ '-' + horizontalGaps[1] };
  ` }

  ${ media.desktop`
    margin-left: ${ '-' + horizontalGaps[2] };
    margin-top: 100px;
  ` }
`

const StyledItem = styled.li`
  margin-bottom: ${ verticalGaps[0] + 'px' };
  padding-left: 125px;
  position: relative;

  ${ media.tablet`
    text-align: center;
    padding-left: 0;
    width: 27.5%;
    margin-bottom: ${ verticalGaps[1] + 'px' };
    margin-left: ${ horizontalGaps[1] };
  ` }

  ${ media.desktop`
    width: 25.8%;
    margin-bottom: ${ verticalGaps[2] + 'px' };
    margin-left: ${ horizontalGaps[2] };
  ` }
`

const StyledBreak = styled.div`
  ${ media.tablet`
    width: 100%;
  ` }
`

const StyledItemImage = styled(ArBaseImage)`
  width: 100px;
  position: absolute;
  top: 0;
  left: 0;

  ${ media.tablet`
    position: static;
    width: 130px;
    margin-bottom: 30px;
    margin-left: auto;
    margin-right: auto;
  ` }
`

const StyledItemTitle = styled.h3`
  font-size: 18px;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Bold };
  letter-spacing: 0.01em;
  line-height: 1;
  margin-bottom: 10px;

  ${ media.desktop`
    font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
    font-size: 28px;
  ` }
`

const StyledItemSubtitle = styled.h4`
  color: ${ p => p.theme.colors.flowerViolet };
  font-family: ${ ({ theme }) => theme.font.secondary };
  font-size: 14px;
  font-weight: ${ ({ theme }) => theme.fontWeight.secondary.Regular };
  letter-spacing: 0.01em;
  line-height: 1;
  margin-bottom: 15px;

  ${ media.tablet`
    margin-bottom: 20px;
  ` }
`

const StyledItemDescription = styled.p`
  font-size: 14px;
  letter-spacing: 0.01em;
  line-height: 1.57;

  ${ media.tablet`
    font-size: 18px;
  ` }
`

class ArCompanyTeam extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    team: PropTypes.arrayOf(PropTypes.shape({
      image: PropTypes.object,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      description: PropTypes.string,
    })),
  }

  render () {
    const { title, description, team } = this.props

    return (
      <StyledWrapper>
        <StyledContainer>
          <StyledTitle>{ title }</StyledTitle>
          <StyledDescription>{ description }</StyledDescription>
          <StyledList>
            {team.map(({ image, title, subtitle, description }, index) => {
              return (
                <React.Fragment key={index}>
                  {index === 2 && <StyledBreak />}

                  <StyledItem key={index}>
                    <StyledItemImage src={image.url} aspectRatio={1}/>
                    <StyledItemTitle>{ title }</StyledItemTitle>
                    <StyledItemSubtitle>{ subtitle }</StyledItemSubtitle>
                    <StyledItemDescription>{ description }</StyledItemDescription>
                  </StyledItem>
                </React.Fragment>
              )
            })}
          </StyledList>
        </StyledContainer>
      </StyledWrapper>
    )
  }
}

export default ArCompanyTeam
